import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';

let CD;

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        async onExport() {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const details = await this.getExportData(this.queryParams);

                const sheet = this.getSheet(details);
                if (sheet) MyXLSX2.bookAppendSheet(wb, sheet, '匯出');

                MyXLSX2.download(wb, `外部進項發票${CD}`);
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },

        getSheet(details) {
            const title = '外部進項發票';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '系統單號', align: 'left' },
                { text: '發票號碼', align: 'left' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '發票日期', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '稅額', align: 'right', number: true },
                { text: '金額', align: 'right', number: true },
                { text: '填寫人', align: 'center' },
                { text: '建立日期', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.customNumber,
                    item.foo || '--',
                    item.description || '--',
                    item.foO_DAT ? moment(item.foO_DAT).format('YYYY-MM-DD') : '--',
                    item.amt - item.tax,
                    item.tax,
                    item.amt,
                    item.crT_USR,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalNonTaxAmt = _.sumBy(details, (o) => o.amt - o.tax);
            const totalTaxAmt = _.sumBy(details, (o) => o.tax);
            const totalAmt = _.sumBy(details, (o) => o.amt);
            bodyRows.push(['', '總計', '', '', '', totalNonTaxAmt, totalTaxAmt, totalAmt, '', '']);
            const PHASE_LABEL = _.find(this.phaseOptions, ['sno', this.phase]);

            // 表頭資訊
            const headRows = [
                { label: '未稅金額總計', value: totalNonTaxAmt },
                { label: '稅額總計', value: totalTaxAmt },
                { label: '金額總計', value: totalAmt },
                { label: '匯出期別', value: `${this.year}年${PHASE_LABEL.label}` },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;

            const url = 'PaymentInvoice/QueryPaymentInvoice';

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: { ...params, PageNum: 1, PageSize },
            });

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { ...params, PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },
    },
};
